import "../css/ActionPopup.css";

export default function ActionPopup({
  name,
  children,
  onClose,
  simple,
  overflowStyle = true,
  customClass = "",
  fullscreen = false,
}) {
  return (
    <div className="popup-container">
      <div
        className={`ap-container popup-screen ${
          name === "Extras" || name === "Datos sanitarios" ? "w-custom" : ""
        } ${name === "Datos sanitarios" ? "popup-health-data" : ""} ${
          fullscreen ? "fullscreen" : ""
        }`}
      >
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">{name}</span>
          {!simple && (
            <button className="popup-action-icon close-icon" onClick={onClose}>
              <img
                src="/images/close-white.svg"
                loading="lazy"
                alt="Icon"
              ></img>
            </button>
          )}
        </div>
        <div
          className={`tab-content ap-content background-gray ${
            !overflowStyle ? "tab-content-no-overflow" : ""
          } ${customClass}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
